import React from 'react';
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Box,
  Avatar,
  useTheme
} from '@mui/material';
import {
  FaUserFriends,
  FaCheckCircle,
  FaClock,
  FaTimesCircle,
  FaUserTie,
  FaShoppingCart,
  FaServicestack,
  FaTools,
  FaGraduationCap
} from "react-icons/fa";

const CARD_STYLES = {
  purple: { main: '#7c3aed', light: '#f3e8ff', border: '#7c3aed' },
  gradient: { main: '#2563eb', light: '#eff6ff', border: '#2563eb' },
  soft: { main: '#f59e0b', light: '#fffbeb', border: '#f59e0b' },
  rejected: { main: '#dc2626', light: '#fef2f2', border: '#dc2626' },
  buyers: { main: '#0891b2', light: '#ecfeff', border: '#0891b2' },
  orders: { main: '#4f46e5', light: '#eef2ff', border: '#4f46e5' },
  services: { main: '#db2777', light: '#fce7f3', border: '#db2777' },
  rentals: { main: '#059669', light: '#ecfdf5', border: '#059669' },
  trainings: { main: '#8b5cf6', light: '#ede9fe', border: '#8b5cf6' },
};

function Cards({ stats }) {
  const theme = useTheme();

  const cardData = [
    { title: "Total Sellers", value: stats.totalSellers || 0, icon: <FaUserFriends size={24} />, type: "purple" },
    { title: "Approved Sellers", value: stats.approvedSellers || 0, icon: <FaCheckCircle size={24} />, type: "gradient" },
    { title: "Pending Sellers", value: stats.pendingSellers || 0, icon: <FaClock size={24} />, type: "soft" },
    { title: "Rejected Sellers", value: stats.rejectedSellers || 0, icon: <FaTimesCircle size={24} />, type: "rejected" },
    { title: "Total Buyers", value: stats.totalBuyers || 0, icon: <FaUserTie size={24} />, type: "buyers" },
    { title: "Total Orders", value: stats.totalOrders || 0, icon: <FaShoppingCart size={24} />, type: "orders" },
    { title: "Total Services", value: stats.totalServices || 0, icon: <FaServicestack size={24} />, type: "services" },
    { title: "Total Rentals", value: stats.totalRentals || 0, icon: <FaTools size={24} />, type: "rentals" },
    { title: "Total Trainings", value: stats.totalTrainings || 0, icon: <FaGraduationCap size={24} />, type: "trainings" },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Grid container spacing={2}>
        {cardData.map((card, index) => {
          const styles = CARD_STYLES[card.type] || CARD_STYLES.purple;

          return (
            <Grid size={{ xs: 12, sm: 6, md: 4, lg: 4 }} key={index}>
              <Card
                sx={{
                  height: '100%',
                  position: 'relative',
                  overflow: 'visible',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  borderBottom: `4px solid ${styles.border}`,
                  '&:hover': {
                    transform: 'translateY(-5px)',
                    boxShadow: theme.shadows[8],
                  }
                }}
              >
                <CardContent sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', p: 2, '&:last-child': { pb: 2 } }}>
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: 1, fontWeight: 600, mb: 0.5, fontSize: '0.7rem' }}>
                      {card.title}
                    </Typography>
                    <Typography variant="h5" component="div" sx={{ fontWeight: 700, color: 'text.primary' }}>
                      {card.value}
                    </Typography>
                  </Box>
                  <Avatar
                    sx={{
                      bgcolor: styles.light,
                      color: styles.main,
                      width: 48,
                      height: 48,
                      borderRadius: 2,
                      boxShadow: '0 4px 6px -1px rgba(0,0,0,0.05)'
                    }}
                  >
                    {card.icon}
                  </Avatar>
                </CardContent>
              </Card>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
}

export default Cards;